import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Modal, Button } from 'antd';

export default class GuarantorInfoModal extends React.Component {
  render() {
    const { t, guarantor, payload, showGuarantorInfoModal, onCancel } = this.props;

    return (
      <Modal
        visible={showGuarantorInfoModal}
        onCancel={onCancel}
        footer={null}
        width={'880px'}
        zIndex={10000000}
        wrapClassName="guarantor-info-modal"
      >
        <div className="charge-modal__content">
          <h3 className="charge-modal__title">
            {t('landlord.long_tail.booking_details.charge_modal.title.guarantor_info_details')}
          </h3>
          <div className="longtail-booking-details__block-row-guarantor-container">
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.guarantor_info.first_name', {
                value: guarantor && guarantor.firstName ? guarantor.firstName : '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.guarantor_info.last_name', {
                value: guarantor && guarantor.lastName ? guarantor.lastName : '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.guarantor_info.relationship', {
                value:
                  guarantor && guarantor.relationshipWithStudent
                    ? t(
                        `landlord.long_tail.booking_details.field.relationship.${guarantor.relationshipWithStudent.toLowerCase()}`,
                      )
                    : '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.student_info.date_of_birth', {
                value:
                  guarantor && guarantor.dateOfBirth
                    ? moment(guarantor.dateOfBirth).format('DD/MM/YYYY')
                    : '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.student_info.email', {
                value:
                  guarantor && guarantor.emailAddress
                    ? this.props.hiddenEmailByStatus(
                        guarantor.emailAddress,
                        payload.stage,
                        payload.secondaryStage,
                      )
                    : '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.student_info.phone_number', {
                value:
                  guarantor && guarantor.phone
                    ? this.props.hiddenPhoneByStatus(
                        guarantor.phone,
                        payload.stage,
                        payload.secondaryStage,
                      )
                    : '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.student_info.city_country', {
                value: `${guarantor?.city}(${guarantor?.country})` ?? '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.student_info.zip_code', {
                value: guarantor && guarantor?.postalCode ? guarantor.postalCode : '-',
              })}
            </p>
            <p className="longtail-booking-details__line">
              {t('landlord.long_tail.booking_details.label.student_info.address', {
                value: guarantor?.addressLines ?? '-',
              })}
            </p>
          </div>
        </div>

        <div className="charge-modal__footer">
          <Button type="primary" size="large" onClick={onCancel}>
            {t('landlord.long_tail.booking_details.transfer_modal.btn.close')}
          </Button>
        </div>
      </Modal>
    );
  }
}

GuarantorInfoModal.propTypes = {
  t: PropTypes.func,
  hiddenEmailByStatus: PropTypes.func,
  hiddenPhoneByStatus: PropTypes.func,
  guarantor: PropTypes.object,
  payload: PropTypes.object,
  showGuarantorInfoModal: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
};

GuarantorInfoModal.defaultProps = {
  t: () => {},
  hiddenEmailByStatus: () => {},
  hiddenPhoneByStatus: () => {},
  guarantor: {},
  payload: {},
};
